import request from '@/utils/request'

// 获取已完成配料的订单明细（用于派工单）
export const getCompletedOrderItemMatchings = (params) => {
  const countOnly = params && (params.count_only === true || params.count_only === 1 || params.count_only === '1')
  return request({
    url: '/api/dispatch-orders/completed-matchings',
    method: 'get',
    params,
    // 角标轻量计数不占全局并发名额，避免拖死收款单等业务页加载
    skipRequestGuard: !!countOnly
  })
}

// 创建派工单
export const createDispatchOrder = (data) => {
  return request({
    url: '/api/dispatch-orders',
    method: 'post',
    data
  })
}

/** 合并数量：将多条明细设为同一合并组（仓库按组合计量） */
export const applyDispatchMergeQuantity = (dispatchOrderId, orderItemIds) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/merge-quantity`,
    method: 'post',
    data: { order_item_ids: orderItemIds || [] }
  })
}

/** 拆分合并数量：清除所选明细上的合并分组 */
export const splitDispatchMergeQuantity = (dispatchOrderId, orderItemIds) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/merge-quantity/split`,
    method: 'post',
    data: { order_item_ids: orderItemIds || [] }
  })
}

// 获取派工单列表
export const getDispatchOrders = (params) => {
  return request({
    url: '/api/dispatch-orders',
    method: 'get',
    params
  })
}

/** 派工明细汇总（按分码支展开）；export_all=true 用于 Excel 导出 */
export const getDispatchOrderLineDetails = (params) => {
  return request({
    url: '/api/dispatch-orders/line-details',
    method: 'get',
    params
  })
}

// 获取派工单详情（config.params 可传 enforce_my_dispatch=true 等）
export const getDispatchOrder = (dispatchOrderId, config = {}) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}`,
    method: 'get',
    params: config.params || {}
  })
}

/** 获取某派工单明细的分码记录 */
export const getDispatchOrderItemBranchRecords = (dispatchOrderItemId) => {
  return request({
    url: `/api/dispatch-order-items/${dispatchOrderItemId}/branch-records`,
    method: 'get'
  })
}

/**
 * 覆盖保存分码记录
 * @param {number} dispatchOrderItemId
 * @param {Array|{ branches: Array, inventory_verified?: boolean }} branchesOrPayload 分码数组，或含 inventory_verified 的对象
 */
/** 移动端：本分卷已确认（服务端存储，多终端同步） */
export const setDispatchOrderItemMobileSlittingConfirmed = (dispatchOrderItemId, data) => {
  return request({
    url: `/api/dispatch-order-items/${dispatchOrderItemId}/mobile-slitting-confirmed`,
    method: 'post',
    data: data || { confirmed: true }
  })
}

/** 现场确认：实跑与系统参考账面相符，写入库存实跑标记 */
export const confirmDispatchItemPhysicalRun = (dispatchOrderItemId, data) => {
  return request({
    url: `/api/dispatch-order-items/${dispatchOrderItemId}/confirm-inventory-physical-run`,
    method: 'post',
    data: data || {}
  })
}

export const saveDispatchOrderItemBranchRecords = (dispatchOrderItemId, branchesOrPayload) => {
  const data = Array.isArray(branchesOrPayload)
    ? { branches: branchesOrPayload }
    : {
        branches: branchesOrPayload.branches || [],
        ...(branchesOrPayload.inventory_verified !== undefined
          ? { inventory_verified: branchesOrPayload.inventory_verified }
          : {})
      }
  return request({
    url: `/api/dispatch-order-items/${dispatchOrderItemId}/branch-records`,
    method: 'put',
    data
  })
}

/** 派工反写拆单：按已保存分码合计拆分订单行，余量回到配料 */
export const splitDispatchOrderItemByActualBranches = (dispatchOrderItemId, data = {}) => {
  return request({
    url: `/api/dispatch-order-items/${dispatchOrderItemId}/split-by-actual-branches`,
    method: 'post',
    data
  })
}

/** 仓库现场完成工单（含数量核对） */
export const warehouseCompleteDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/warehouse-complete`,
    method: 'post',
    data
  })
}

/** 仓库现场：包装要求、整单称重/外尺寸 */
export const saveDispatchWarehousePackaging = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/warehouse-packaging`,
    method: 'put',
    data
  })
}

/** 按支（分码行）保存称重与外包装尺寸 */
export const saveDispatchBranchPackMeasures = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/branch-pack-measures`,
    method: 'put',
    data
  })
}

// 指派派工单给人员
export const assignDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/assign`,
    method: 'put',
    data
  })
}

// 更新派工单状态
export const updateDispatchOrderStatus = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/status`,
    method: 'put',
    data
  })
}

// 编辑派工单
export const updateDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}`,
    method: 'put',
    data
  })
}

// 删除派工单
export const deleteDispatchOrder = (dispatchOrderId) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}`,
    method: 'delete'
  })
}

// 审核派工单
export const auditDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/audit`,
    method: 'post',
    data
  })
}

/** 取消审核（恢复为待审核，需 orders.dispatch.unaudit） */
export const revokeDispatchOrderAudit = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/revoke-audit`,
    method: 'post',
    data: data || {}
  })
}

/** 第二轮：仓库完成后业务现场核销 */
export const postCompletionAuditDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/post-completion-audit`,
    method: 'post',
    data
  })
}

export const revokePostCompletionAuditDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/revoke-post-completion-audit`,
    method: 'post',
    data: data || {}
  })
}

/** 管理员：单独作废派工明细行（不取消整单核销） */
export const voidDispatchOrderItem = (dispatchOrderId, dispatchOrderItemId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/items/${dispatchOrderItemId}/void`,
    method: 'post',
    data: data || {}
  })
}

/** 现场提交包装资料业务核销（与打码核销分离） */
export const submitPackagingAuditDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/packaging-audit/submit`,
    method: 'post',
    data: data || {}
  })
}

/** 业务审核包装称重/外尺寸 */
export const packagingAuditDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/packaging-audit`,
    method: 'post',
    data
  })
}

export const revokePackagingAuditDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/revoke-packaging-audit`,
    method: 'post',
    data: data || {}
  })
}

/** 业务员将已完成的派工单退回仓库修改 */
export const requestReopenDispatchOrder = (dispatchOrderId, data) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/request-reopen`,
    method: 'post',
    data
  })
}

// 打印派工单
export const printDispatchOrder = (dispatchOrderId) => {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/print`,
    method: 'post'
  })
}

// 将订单明细退回配料
export const returnOrderItemToMatching = (orderItemId) => {
  return request({
    url: `/api/order-items/${orderItemId}/return-to-matching`,
    method: 'post'
  })
}

